import { useEffect, useRef } from 'react';

export default function useDidUpdateEffect(
  fn: (prevInputs: any[]) => Function | void,
  inputs: any[],
) {
  const fncRef = useRef<Function>();
  const inputsRef = useRef<any[]>(inputs);
  fncRef.current = fn;
  const didMountRef = useRef(false);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
    } else {
      if (fncRef.current) {
        const oldInputs = [...inputsRef.current];
        inputsRef.current = inputs;
        const cleanUp = fncRef.current(oldInputs);
        return () => {
          if (typeof cleanUp === 'function') {
            cleanUp();
          }
          inputsRef.current = [];
        };
      }
    }
  }, inputs);
}
